import { initGoogleMaps } from '../../../common/scripts/helpers/google-maps';

/**
 * Initialization of step 2
 */
function initStepResult() {
  if (document.getElementById("map")) {
    initGoogleMaps();
  }
  initReadmore();

  /**
   * Read more
   */
  // Variables
  function initReadmore() {
    var $readMoreWrappers = $(".read-more-wrapper");
    var $readMoreChevrons = $readMoreWrappers.find("svg");

    // Open icon
    $readMoreChevrons.on("click", function () {
      var $readMoreText = $(this).prev();
      var $readMoreWrapper = $(this).parent();

      if ($readMoreWrapper.hasClass("open") === true) {
        // Close if open
        $readMoreText.attr("style", "");
        $readMoreWrapper.removeClass("open");
      } else {
        // Open if not open
        $readMoreText.css(
          "max-height",
          "calc(" + $readMoreText.get(0).scrollHeight + "px + 1.5rem)"
        );
        $readMoreWrapper.addClass("open");
      }
    });
  }
}

export { initStepResult };
